const authorizationToken = process?.env?.SLUG_RESOLUTION_SERVICE_AUTH_TOKEN ?? ''
const slugResolutionServiceUrl = process?.env?.SLUG_RESOLUTION_SERVICE_URL ?? ''
const contentfulSpaceId = process?.env?.CONTENTFUL_SPACE_ID ?? ''

type SlugServiceResponseData = {
  slug: string
  spaceId: string
  createdAt: string
  entryId: string
}

type SlugServiceResponse = {
  data: SlugServiceResponseData[] | null
  status: number
}

export const slugService = async (slug: string): Promise<SlugServiceResponse> => {
  const badResponse: SlugServiceResponse = { data: null, status: 500 }

  try {
    const params = {
      url: `${slugResolutionServiceUrl}/slug/${encodeURI(slug)}?spaceId=${contentfulSpaceId}`,
      options: {
        headers: {
          authorization: authorizationToken
        },
        method: 'GET'
      }
    }

    const response = await fetch(params.url, params.options)

    if (response.status === 200) {
      const data = await response.json()

      return { data, status: response.status }
    } else {
      return { ...badResponse, status: response.status || 500 }
    }
  } catch (error) {
    console.error(error)
    return badResponse
  }
}
